export const USER_ENDPOINTS = {
    GET_USER: 'get-create-user',
    UPDATE_USER: 'user',
    GET_OR_CREATE_USER: 'users',
}

export const API_ENDPOINTS = {
    SEASON_EVENTS: 'events',
    GET_FEED: 'feeds',
    GET_GAME_HIGHLIGHTS: 'game-highlights'
}

export const GAMIFCATION_ENDPOINTS = {
    GET_CONFIG: 'configuration',
    ENGAGEMENT: `user-engagement`,
}